"use client";
import {
  Box,
  Button,
  HStack,
  Icon,
  Text,
  Stack,
  SimpleGrid,
  GridItem,
} from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { FaRegEye } from "@onemind-services-llc/react-icons-ng/fa";
import { SectionDivider } from "@/app/components/shared/SectionDivider";
import { TEXT_VARIANTS } from "@/theme/components/text";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import SecAwardsLogo from "public/home/secAwardsLogo.png";
import { HEADING_CONSTANTS, ACHIEVEMENTS_LIST } from "./constants";

const SecurityAchievements = () => {
  return (
    <Box id="sec-achievements">
      <SectionDivider label={HEADING_CONSTANTS.title} />
      <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 8 }} mb={8}>
        <GridItem colSpan={{ base: 1, md: 4 }}>
          <Text variant={TEXT_VARIANTS.BODY1} color="gray.700">
            {HEADING_CONSTANTS.description}
          </Text>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 1 }}>
          <Image
            src={SecAwardsLogo}
            alt="Security Awards Logo"
            width={250}
            height={250}
          />
        </GridItem>
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={{ base: 8, lg: 16 }}>
        {ACHIEVEMENTS_LIST.map((achievement) => (
          <GridItem key={achievement.title} boxShadow={"xl"} p={6} borderRadius="lg">
            <Stack justifyContent="space-between" h="100%" spacing={4}>
              <HStack spacing={3}>
                <Icon as={achievement.icon} w={8} h={6} />
                <Text variant={TEXT_VARIANTS.BODY1} fontWeight={600}>
                  {achievement.title}
                </Text>
              </HStack>
              <Text variant={TEXT_VARIANTS.BODY1} color="gray.600">
                {achievement.desc}
              </Text>
              <Button
                as={Link}
                href={achievement.pdfSrc}
                target="_blank"
                rel="noopener noreferrer"
                w="fit-content"
                fontSize={"20px"}
                fontWeight={500}
                variant={BUTTON_VARIANTS.SECONDARY}
                leftIcon={<FaRegEye />}
              >
                Preview
              </Button>
            </Stack>
          </GridItem>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default SecurityAchievements;
